export const computeBodyTypeURL = ({ value }) => {
    const keyword = value.toLowerCase().split(" ").join("-");
    return [keyword, "cars"];
};
